import React from "react";
import { CourseValidationError } from "src/types/coaching/courses";

export interface CourseContextProps {
  id?: string;
  courseContent?: string;
  preferences?: any;
  validationError?: CourseValidationError;

  // eslint-disable-next-line no-unused-vars
  gotoError(error?: CourseValidationError): void;
  
  // eslint-disable-next-line no-unused-vars
  updatePreferences?: (preferences: any) => void;
}

export const CourseContext = React.createContext<CourseContextProps>({
  gotoError: () => {}
});

export interface SimulationContextProps {
  id?: string;
  editSimulationAssessment: any;
  setEditSimulationAssessment: (editSimulationAssessment: any) => void;
}

export const SimulationContext = React.createContext<SimulationContextProps>({
  editSimulationAssessment: {},
  setEditSimulationAssessment: () => {}
});